module.exports = __webpack_public_path__ + "images/vef.6c511b7d3bfe19bff61048ba99234769.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/flags/vef.png
// module id = 446
// module chunks = 0